import ServiceBase from '../ServiceBase';
import masterProxy from '../../proxies/common/MasterProxy';

const CACHE_MIN = 60;

class MasterService extends ServiceBase {
  // List ticker
  getListOrganization(params) {
    return this.applyMemoryCache(
      'MasterService.getListOrganization',
      params,
      null,
      CACHE_MIN,
    )(() => masterProxy.getListOrganization(params));
  }

  // List Index
  getAllCompanyGroup(params) {
    return this.applyMemoryCache(
      'MasterService.getAllCompanyGroup',
      params,
      null,
      CACHE_MIN,
    )(() => masterProxy.getAllCompanyGroup(params));
  }

  // icb: icbLevel=3
  getAllIcbIndustry(params) {
    return this.applyMemoryCache(
      'MasterService.getAllIcbIndustry',
      params,
      null,
      CACHE_MIN,
    )(() => masterProxy.getAllIcbIndustry(params));
  }

  // ListDerivatives
  getAllDerivatives(params) {
    return this.applyMemoryCache(
      'MasterService.getAllDerivatives',
      params,
      null,
      CACHE_MIN,
    )(() => masterProxy.getAllDerivatives(params));
  }

  // ListDerivatives for charting
  getAllDerivativesForChart(params) {
    return this.applyMemoryCache(
      'MasterService.getAllDerivativesForChart',
      params,
    )(() => masterProxy.getAllDerivativesForChart(params));
  }

  // ListEconomy
  getAllChartEconomy(params) {
    return this.applyMemoryCache('MasterService.getAllChartEconomy', params)(
      () => masterProxy.getAllChartEconomy(params),
    );
  }

  getAllCoveredWarrants(params) {
    return this.applyMemoryCache('MasterService.getAllChartEconomy', params)(
      () => masterProxy.getAllCoveredWarrants(params),
    );
  }

  getTimeOffset() {
    const params = { clientTime: new Date() };
    return this.applyMemoryCache('MasterService.getTimeOffset', params)(() =>
      masterProxy.getTimeOffset(params),
    );
  }

  getSharedChartLayout(data) {
    return this.applyMemoryCache('MasterService.GetSharedChartLayout', data)(
      () => masterProxy.getSharedChartLayout(data),
    );
  }

  getGuestWorkSpace(data) {
    return this.applyMemoryCache('MasterService.getGuestWorkSpace', data)(() =>
      masterProxy.getGuestWorkSpace(data),
    );
  }
}

const masterService = new MasterService();
export default masterService;
